import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "#666E81" }, [
      _createElementVNode("path", { d: "M6.388 15.739c-3.197-3.607-3.181-8.28.075-11.493 3.285-3.243 9.338-3.043 11.945.817 1.303 1.929 1.691 3.655 1.563 5.34-.201 2.656-2.036 4.946-4.172 7.166l-4.876 5.068L12.378 24l4.875-5.068c2.121-2.205 4.458-4.952 4.718-8.38.164-2.153-.358-4.313-1.894-6.587-3.41-5.048-10.985-5.113-15.032-1.119-4.076 4.023-3.988 9.885-.166 14.196.365.411.998.453 1.415.093a.98.98 0 0 0 .094-1.396Z" }),
      _createElementVNode("path", { d: "m14.11 5.009 2.488 6.195.734.002v.932h-3.761v-.932h.554l-.54-1.539-1.573 2.544-1.573-2.544-.54 1.54h.555v.93H6.708v-.93h.719l2.488-6.198 2.098 3.622 2.097-3.622Z" })
    ], -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "ClinicMetro"}) } }